import type { ReviewEntryQuestion } from '../../../../../types/reviewEntryQuestion'

// Deterministic key used to track dismissed clarifications per entry. Must be called with the
// same `index` the caller uses to iterate the filtered clarifications list (i.e. the output of
// `getClarificationQuestions`) so keys stored via `handleDismissClarification` line up with the
// keys derived when detecting outstanding clarifications elsewhere (e.g. bulk validate confirm).
export const getClarificationQuestionKey = (entryId: string, question: ReviewEntryQuestion, index: number): string => {
  const questionId = question.id?.trim()

  return questionId ? `${entryId}:${questionId}-${index}` : `${entryId}:question-${index}`
}
